import * as React from 'react';

const SvgPlayPause: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 15h2V9h-2v6zM15 15h2V9h-2v6zM7 9v6l4-3-4-3zM8 3l4-3v6L8 3zM16 21l-4 3v-6l4 3z"
        fill="currentColor"
      />
      <path
        d="M11.75 2H12c5.514 0 10 4.486 10 10a9.992 9.992 0 01-4.007 8l-1.682-1.264A8.002 8.002 0 0020 12c0-4.409-3.591-8-8-8h-.25V2zM4 12c0 4.409 3.591 8 8 8h.25v2H12C6.486 22 2 17.514 2 12a9.993 9.993 0 014.007-8l1.682 1.265A8.002 8.002 0 004 12z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgPlayPause;
